import { Group, Paper, Stack, Text } from '@mantine/core';

import CheckOutlineIcon from '@/assets/icons/content/check-outline.svg';

import type { GslSection } from '../../utils/gslSections';

import classes from './GslCards.module.css';

const GslCard = ({ title, items }: GslSection) => (
  <Paper withBorder shadow="none" radius={2} p={16} className={classes.card}>
    <Stack gap={20} className={classes.cardBody}>
      <Text className={classes.cardTitle}>{title}</Text>
      <Stack gap={20} component="ul" aria-label={title} className={classes.list}>
        {items.map((item) => (
          <Group key={item} component="li" gap={10} wrap="nowrap" className={classes.row}>
            <CheckOutlineIcon className={classes.icon} aria-hidden="true" />
            <Text span className={classes.name}>
              {item}
            </Text>
          </Group>
        ))}
      </Stack>
    </Stack>
  </Paper>
);

const GslCards = ({ sections }: { sections: GslSection[] }) => {
  if (sections.length === 0) return null;

  return (
    <div className={classes.grid}>
      {sections.map((section) => (
        <GslCard key={section.title} {...section} />
      ))}
    </div>
  );
};

export default GslCards;
